import { TWorkflowExecution } from '@commenda/types';
import {
  ServiceRequestDetails,
  TaskGroupWithSLA,
} from '@commenda/types/src/service-request/types';
import { TaskParty } from '@prisma/client';
import { KeyedMutator } from 'swr';
import { isSkippedByBranch } from '../../../../utils';
import { ServiceRequestTimelineTask } from './ServiceRequestTimelineTask';

type ServiceRequestTimelineTaskGroupProps = {
  serviceRequest: ServiceRequestDetails;
  taskGroup: TaskGroupWithSLA;
  role: TaskParty;
  mutate: KeyedMutator<unknown>;
  workflowExecution?: TWorkflowExecution;
};

export const ServiceRequestTimelineTaskGroup = ({
  serviceRequest,
  taskGroup,
  role,
  mutate,
  workflowExecution,
}: ServiceRequestTimelineTaskGroupProps) => {
  const visibleTasks =
    taskGroup?.tasks?.filter((task) => !isSkippedByBranch(task)) ?? [];

  return visibleTasks.map((task, i, arr) => (
    <ServiceRequestTimelineTask
      key={task.id}
      isFirst={i === 0}
      isLast={i === arr.length - 1}
      serviceRequest={serviceRequest}
      taskGroup={taskGroup}
      role={role}
      task={task}
      mutate={mutate}
      workflowExecution={workflowExecution}
    />
  ));
};
